import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AnimatePresence, motion } from 'framer-motion';
import theme from './theme';

// Components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Project from './components/Projects';
import EmergencyProject from './components/EmergencyProject';
import MIAProject from './components/MIAProject';
import FundingApp from './components/FundingApp';
import Simptel from './components/Simptel';
import SimacOnboarding from './components/SimacOnboarding';
import FinTechTeens from './components/FinTechTeens';
import Footer from './components/Footer';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Animated Routes with padding to avoid navbar overlap
function AnimatedRoutes() {
  const location = useLocation();
  const navHeight = 64; // Adjust if your AppBar height is different

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 30 }}
              transition={{ duration: 0.5 }}
              style={{ paddingTop: navHeight }}
            >
              <Hero />
            </motion.div>
          }
        />
        <Route
          path="/about"
          element={
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
              style={{ paddingTop: navHeight }}
            >
              <About />
            </motion.div>
          }
        />
        <Route
          path="/projects"
          element={
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.5 }}
              style={{ paddingTop: navHeight }}
            >
              <Project />
            </motion.div>
          }
        />
        <Route
          path="/projects/emergency"
          element={
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.5 }}
              style={{ paddingTop: navHeight }}
            >
              <EmergencyProject />
            </motion.div>
          }
        />
        <Route
          path="/projects/MIA"
          element={
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.5 }}
              style={{ paddingTop: navHeight }}
            >
              <MIAProject />
            </motion.div>
          }
        />
        <Route
          path="/projects/FundingApp"
          element={
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.5 }}
              style={{ paddingTop: navHeight }}
            >
              <FundingApp/>
            </motion.div>
          }
        />
         <Route
          path="/projects/SimacOnboarding"
          element={
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.5 }}
              style={{ paddingTop: navHeight }}
            >
              <SimacOnboarding/>
            </motion.div>
          }
        />
          <Route
          path="/projects/Simptel"
          element={
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.5 }}
              style={{ paddingTop: navHeight }}
            >
              <Simptel/>
            </motion.div>
          }
        />
             <Route
          path="/projects/FinTechTeens"
          element={
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.5 }}
              style={{ paddingTop: navHeight }}
            >
              <FinTechTeens/>
            </motion.div>
          }
        />
          
      </Routes>
       <Footer />

    </AnimatePresence>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <Navbar />
        <AnimatedRoutes />
      </Router>
    </ThemeProvider>
  );
}

export default App;
